/**
 * SEO Image Constants
 * Centralized Open Graph and social sharing image URLs for SeniorThrive
 * All images should be 1200x630px for optimal social media display
 */

const BASE_URL = 'https://seniorthrive.com';

export const OG_IMAGES = {
  default: `${BASE_URL}/og-images/home.png`,
  home: `${BASE_URL}/og-images/home.png`,
  features: `${BASE_URL}/og-images/features.png`,
  pricing: `${BASE_URL}/og-images/pricing.png`,
  olderAdults: `${BASE_URL}/og-images/older-adults.png`,
  thriveFamily: `${BASE_URL}/og-images/thrivefamily.png`,
  familyCareTools: `${BASE_URL}/og-images/family-care-tools.png`,
  thriveCare: `${BASE_URL}/og-images/thrivecare.png`,
  about: `${BASE_URL}/og-images/about.png`,
  faq: `${BASE_URL}/og-images/faq.png`,
  blog: `${BASE_URL}/og-images/blog.png`,
  professionalNetwork: `${BASE_URL}/og-images/professional-network.png`,
  partners: `${BASE_URL}/og-images/partners.png`,
  affiliate: `${BASE_URL}/og-images/affiliate.png`,
  conversationGuide: `${BASE_URL}/og-images/conversation-guide.png`,
  stories: `${BASE_URL}/og-images/stories.png`,
  sponsorship: `${BASE_URL}/og-images/sponsorship.png`,
  contact: `${BASE_URL}/og-images/contact.png`,
} as const;

/**
 * Logo URL for structured data (schema.org)
 */
export const LOGO_URL = `${BASE_URL}/logo.png`;

/**
 * Favicon URL
 */
export const FAVICON_URL = `${BASE_URL}/favicon.ico`;
